import {
  Component,
  DestroyRef,
  ElementRef,
  inject,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LocaleService } from "../../../shared/services/locale.service";
import {
  externalpageImageTypes,
  externalpageStatuses,
  ExternalpageService,
  schoolTypes,
} from "../../.../../../shared/services/externalpage.service";
import { targetGroupOptions } from "../../../shared/services/job.service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { empty } from "../../../functions";
import { AdminService } from "../../../shared/services/admin.service";
import { catchError } from "rxjs/operators";
import {
  faSave,
  faSpinner,
  faTimes,
  faCopy,
  faLink,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import {
  alertMessages,
  AlertService,
} from "../../../shared/services/alert.service";
import { externalpageTypes } from "../../.../../../shared/services/externalpage.service";
import { DomainService } from "../../../shared/services/domain.service";
import { ApiService } from "../../../shared/services/api.service";
import bsCustomFileInput from "bs-custom-file-input";
import { ModalService } from "../../../shared/services/modal.service";
import { Observable, of } from "rxjs";
import { MeetDayService } from "../../../api/services/meet-day.service";
import {
  Heading,
  Alignment,
  BlockQuote,
  Bold,
  ClassicEditor,
  Code,
  CodeBlock,
  EditorConfig,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  HtmlEmbed,
  Indent,
  Italic,
  Link,
  List,
  MediaEmbed,
  SourceEditing,
  Strikethrough,
  Underline,
  Undo,
  Table,
  TableSelection,
  TableToolbar,
  TodoList,
  Image,
  ImageInsert,
  Essentials,
} from "ckeditor5";
import { RouteValidationService } from "src/app/shared/services/route-validation.service";

@Component({
  selector: "app-admin-externalpage",
  templateUrl: "./admin-externalpage.component.html",
  styleUrls: ["./admin-externalpage.component.scss"],
  standalone: false,
})
export class AdminExternalpageComponent implements OnInit {
  routeValidationService = inject(RouteValidationService);
  private readonly destroyRef = inject(DestroyRef);

  activeEditorTab = 'nl';

  // Icons
  faSave = faSave;
  faSpinner = faSpinner;
  faTimes = faTimes;
  faCopy = faCopy;
  faLink = faLink;
  faChevronLeft = faChevronLeft;

  externalpageTypes = externalpageTypes;
  externalpageImageTypes = externalpageImageTypes;
  schoolTypes: any = schoolTypes;
  targetGroupOptions = targetGroupOptions;

  public Editor = ClassicEditor;
  public editorConfig: EditorConfig = {
    language: this.locale.getCurrentLanguage(),
    licenseKey: "GPL",
    plugins: [
      Heading,
      FontFamily,
      Table,
      TableToolbar,
      Essentials,
      FontSize,
      Alignment,
      FontColor,
      FontBackgroundColor,
      Link,
      Indent,
      Bold,
      Italic,
      Strikethrough,
      Underline,
      Indent,
      List,
      TodoList,
      Image,
      ImageInsert,
      Code,
      CodeBlock,
      MediaEmbed,
      BlockQuote,
      Undo,
      SourceEditing,
      HtmlEmbed,
    ],
    link: {
      addTargetToExternalLinks: true,
    },
    mediaEmbed: {
      previewsInData: true,
    },
    toolbar: [
      "heading",
      "|",
      "fontfamily",
      "fontsize",
      "|",
      "alignment",
      "|",
      "fontColor",
      "fontBackgroundColor",
      "|",
      "bold",
      "italic",
      "strikethrough",
      "underline",
      "|",
      "link",
      "|",
      "outdent",
      "indent",
      "|",
      "bulletedList",
      "numberedList",
      "todoList",
      "|",
      "code",
      "codeBlock",
      "|",
      "mediaEmbed",
      "insertImage",
      "insertTable",
      "|",
      "blockQuote",
      "|",
      "undo",
      "redo",
      "|",
      "sourceEditing",
      "htmlEmbed",
    ],
    image: {
      toolbar: ["linkImage"],
    },
    table: {
      contentToolbar: [
        "tableColumn",
        "tableRow",
        "mergeTableCells",
        "tableCellProperties",
        "tableProperties",
      ],
    },
    heading: {
      options: [
        {
          model: "paragraph",
          title: "Paragraph",
          class: "ck-heading_paragraph",
        },
        {
          model: "heading1",
          view: "h1",
          title: "Heading 1",
          class: "ck-heading_heading1",
        },
        {
          model: "heading2",
          view: "h2",
          title: "Heading 2",
          class: "ck-heading_heading2",
        },
        {
          model: "heading3",
          view: "h3",
          title: "Heading 3",
          class: "ck-heading_heading3",
        },
        {
          model: "heading4",
          view: "h4",
          title: "Heading 4",
          class: "ck-heading_heading4",
        },
        {
          model: "heading5",
          view: "h5",
          title: "Heading 5",
          class: "ck-heading_heading5",
        },
        {
          model: "heading6",
          view: "h6",
          title: "Heading 6",
          class: "ck-heading_heading6",
        },
      ],
    },
  };

  initalLoad = false;
  isLoading = false;
  isProcessing = false;
  isProcessingMainImage = false;
  isProcessingGalleryImage = false;
  isProcessingContentImage = false;

  isUpdate = false;
  pageType = "Generic";

  public id: string | null = null;

  public entity: any = {
    id: "",
    status: externalpageStatuses.Concept, // default status is Concept
    type: "",
    publicationDate: new Date().toISOString(),
    title: "",
    titleEn: "",
    titleDe: "",
    titleFr: "",
    titlePt: "",
    content: "",
    contentEn: "",
    contentDe: "",
    contentFr: "",
    contentPt: "",
    metaDescription: "",
    metaDescriptionEn: "",
    metaDescriptionDe: "",
    metaDescriptionFr: "",
    metaDescriptionPt: "",
    metaKeywords: "",
    metaKeywordsEn: "",
    metaKeywordsDe: "",
    metaKeywordsFr: "",
    metaKeywordsPt: "",
    permalink: "",
    regions: [],
    imageReferences: [],
    meetDayId: null,

    // Event properties
    eventDate: null,
    eventPeriodDescription: "",
    targetGroups: [],

    // Video properties
    videoUri: null,

    // Testimonial properties
    testimonialName: null,
    testimonialOrganisation: null,
    testimonialType: "",
    schoolType: "",
    address: {
      street: "",
      number: "",
      numberSuffix: "",
      postalCode: "",
      city: "",
      country: "",
    },
  };

  imageDataMain = {
    id: <string | null>"",
    imageType: <string | null>"",
    imageUri: <string | null>"",
  };

  imageDataGallery: any[] = [];
  imageDataLogo: any[] = [];
  imageDataContent: any[] = [];

  externalPageStatuses: any = [];
  testimonialTypes: any = [];

  regions = [];

  fileMainImage: any = "";
  fileImageUrl: any = "";
  fileImageName = "";

  fileGalleryImage: any = "";
  fileGalleryImageUrl: any = "";
  fileGalleryImageName = "";

  fileContentImage: any = "";
  fileContentImageUrl: any = "";
  fileContentImageName = "";

  isRootLevel = false;
  displayPermalink = "";
  permalinkValidationError = "";
  permalinkSuggestions: string[] = [];

  public meetDays: any[] = [];

  // @ts-ignore
  @ViewChild("inputFileMainImage") inputFileMainImage: ElementRef;
  // @ts-ignore
  @ViewChild("inputFileGalleryImage") inputFileGalleryImage: ElementRef;
  // @ts-ignore
  @ViewChild("inputFileContentImage") inputFileContentImage: ElementRef;

  /**
   * Constructor
   *
   * @param locale
   */
  constructor(
    public api: ApiService,
    public locale: LocaleService,
    private adminService: AdminService,
    public route: ActivatedRoute,
    public router: Router,
    public externalpageService: ExternalpageService,
    private alertService: AlertService,
    public domain: DomainService,
    public modal: ModalService,
    private elementRef: ElementRef,
    private meetDayService: MeetDayService
  ) {
    this.externalPageStatuses = this.externalpageService.getStatuses();
    this.testimonialTypes = this.externalpageService.getTestimonialTypes();
  }

  /**
   * Ng on init
   */
  ngOnInit(): void {
    bsCustomFileInput.init();

    // Get regions to select
    this.locale.apiGetRegions().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result: any) => {
      if (result) {
        this.regions = Object.assign([], result);
      }
    });

    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params: ParamMap) => {
      const pageType: string = <string>params.get("pageType");
      if (!empty(pageType)) {
        this.pageType = pageType;
        this.entity.type = this.pageType;
      }

      const id: string = <string>params.get("id");
      const isDuplicate = this.route.snapshot.url.some(
        (segment) => segment.path === "duplicate"
      );

      if (!empty(id)) {
        if (isDuplicate) {
          // This is a duplicate operation - load the original and prepare for duplication
          this.isUpdate = false; // This will be a new record
          this.id = null; // Clear the ID since we're creating new
          this.loadOriginalForDuplication(id);
        } else {
          // This is a regular edit operation
          this.initalLoad = true;
          this.isUpdate = true;
          this.id = id;
          this.getSingle(this.id);
          this.getImages(this.id);
        }
      } else {
        // This is a new record
        this.isUpdate = false;

        // Set default value for school type
        if (this.pageType == this.externalpageTypes.School) {
          if (empty(this.entity.schoolType)) {
            this.entity.schoolType = schoolTypes.Middelbaar;
          }
        }

        // Load meetdays for new Project or Event pages
        if (
          this.pageType == this.externalpageTypes.Project ||
          this.pageType == this.externalpageTypes.Event
        ) {
          this.loadMeetDays();
        }
      }
    });

    this.initializeRootLevelState();
  }

  /**
   * Initialize root level state from existing permalink
   */
  private initializeRootLevelState(): void {
    if (this.entity.permalink && this.entity.permalink.startsWith("~")) {
      this.isRootLevel = true;
      this.displayPermalink = this.entity.permalink.substring(1); // Remove ~
    } else {
      this.isRootLevel = false;
      this.displayPermalink = this.entity.permalink || "";
    }

    this.validatePermalink();
  }

  /**
   * Handle root level toggle change (ONLY FOR EVENTS)
   */
  onRootLevelToggle(): void {
    // Only allow root level for events
    if (this.entity.type === this.externalpageTypes.Event) {
      this.updateActualPermalink();
      this.validatePermalink();
    } else {
      this.isRootLevel = false; // Force disable for non-events
    }
  }

  /**
   * Apply a suggested permalink
   */
  applySuggestion(suggestion: string): void {
    this.displayPermalink = suggestion;
    this.onPermalinkChange();
  }

  /**
   * Validate permalink for root level conflicts
   */
  private validatePermalink(): void {
    this.permalinkValidationError = "";
    this.permalinkSuggestions = [];

    // Only validate for root level events
    if (
      this.isRootLevel &&
      this.entity.type === this.externalpageTypes.Event &&
      this.displayPermalink
    ) {
      if (
        !this.routeValidationService.isValidRootLevelPermalink(
          this.displayPermalink
        )
      ) {
        this.permalinkValidationError =
          this.routeValidationService.getValidationErrorMessage(
            this.displayPermalink
          );
        this.permalinkSuggestions =
          this.routeValidationService.suggestAlternatives(
            this.displayPermalink
          );
      }
    }
  }

  /**
   * Handle permalink input change
   */
  onPermalinkChange(): void {
    this.updateActualPermalink();
    this.validatePermalink();
  }

  /**
   * Update the actual entity permalink based on toggle state and display value
   */
  private updateActualPermalink(): void {
    // Only add ~ prefix for events when root level is enabled
    if (this.isRootLevel && this.entity.type === this.externalpageTypes.Event) {
      this.entity.permalink = "~" + this.displayPermalink;
    } else {
      this.entity.permalink = this.displayPermalink;
    }
  }

  /**
   * Get preview URL for the permalink
   */
  getPreviewUrl(): string {
    const baseUrl = window.location.origin;

    if (!this.displayPermalink) {
      return baseUrl;
    }

    // Root level events
    if (this.isRootLevel && this.entity.type === this.externalpageTypes.Event) {
      return `${baseUrl}/${this.displayPermalink}`;
    }

    // Regular events vs other page types
    const pathPrefix =
      this.entity.type === this.externalpageTypes.Event ? "events" : "pages";
    return `${baseUrl}/${pathPrefix}/${this.displayPermalink}`;
  }

  /**
   * Load original data for duplication
   *
   * @param originalId
   */
  private loadOriginalForDuplication(originalId: string): void {
    this.initalLoad = true;
    this.isLoading = true;

    this.externalpageService
      .apiGetExternalPage(originalId)
      .pipe(
        catchError(this.adminService.handleError("apiGetExternalPage", false)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((result: any) => {
        this.initalLoad = false;
        this.isLoading = false;

        if (result !== false) {
          // Create duplicate data from the original
          console.log(result);
          this.entity = {
            ...result,
            id: null, // Clear ID for new record
            title: `Copy of ${result.title}`,
            titleEn: result.titleEn ? `Copy of ${result.titleEn}` : "",
            titleDe: result.titleDe ? `Copy of ${result.titleDe}` : "",
            titleFr: result.titleFr ? `Copy of ${result.titleFr}` : "",
            titlePt: result.titlePt ? `Copy of ${result.titlePt}` : "",
            publicationDate: null, // Clear publication date
            status: "Concept", // Set to concept status
            permalink: this.generateUniquePermalink(
              result.permalink || result.title
            ),
            eventPeriodDescription: null,
            meetDayId: null,
            eventDate: null,
            imageReferences: [], // Clear image references - they can't be duplicated
          };

          // Handle special cases for different page types
          if (
            this.entity.type == this.externalpageTypes.School &&
            !this.entity.address
          ) {
            this.entity.address = {
              street: "",
              number: "",
              numberSuffix: "",
              postalCode: "",
              city: "",
              country: "",
            };
          }

          if (
            this.entity.type == this.externalpageTypes.Project ||
            this.entity.type == this.externalpageTypes.Event
          ) {
            this.loadMeetDays();
          }

          this.initializeRootLevelState();
        }
      });
  }

  /**
   * Duplicate current event (for use in form)
   */
  duplicateCurrentEvent(): void {
    if (!this.isUpdate || !this.entity.id) {
      return;
    }

    // Navigate to duplicate route with current event ID
    this.router.navigate([
      "/admin/externalpage",
      this.pageType,
      "duplicate",
      this.entity.id,
    ]);
  }

  /**
   * Check if this is duplicate mode
   */
  isDuplicateMode(): boolean {
    return this.route.snapshot.url.some(
      (segment) => segment.path === "duplicate"
    );
  }

  /**
   * Generate a unique permalink for the duplicated event
   */
  private generateUniquePermalink(originalPermalink: string): string {
    const timestamp = Date.now();
    const basePermalink = originalPermalink
      .replace(/[^a-zA-Z0-9-]/g, "-")
      .toLowerCase();
    return `${basePermalink}-copy-${timestamp}`;
  }

  /**
   * Get single data
   *
   * @param $id
   */
  getSingle($id: string) {
    this.isLoading = true;

    this.externalpageService
      .apiGetExternalPage($id)
      .pipe(
        catchError(this.adminService.handleError("apiGetExternalPage", false)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((result: any) => {
        this.initalLoad = false;
        this.isLoading = false;

        if (result !== false) {
          this.entity = Object.assign({}, result);

          // If page type is school and is empty then add empty address
          if (this.entity.type == this.externalpageTypes.School) {
            if (!this.entity.address) {
              this.entity.address = {
                street: "",
                number: "",
                numberSuffix: "",
                postalCode: "",
                city: "",
                country: "",
              };
            }
          }

          if (
            this.entity.type == this.externalpageTypes.Project ||
            this.entity.type == this.externalpageTypes.Event
          ) {
            this.loadMeetDays();
          }

          this.initializeRootLevelState();

          this.parseImages();
        }
      });
  }

  loadMeetDays(): void {
    this.meetDayService.getMeetDays({ PageNumber: 1, PageSize: 1000 })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        if (response?.data) {
          this.meetDays = [...response.data];
        }
      });
  }

  /**
   * Get images of external page
   *
   * @param $id
   */
  getImages($id: string) {
    this.externalpageService
      .apiGetExternalPageImages($id)
      .pipe(
        catchError(
          this.adminService.handleError("apiGetExternalPageImages", false)
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((result: any) => {
        if (result !== false) {
          this.entity.imageReferences = Object.assign([], result);

          this.parseImages();
        }
      });
  }

  /**
   * Parse all image data of entity into distinctive objects for preview
   */
  parseImages() {
    this.imageDataMain = {
      id: null,
      imageType: null,
      imageUri: null,
    };

    this.imageDataGallery = [];
    this.imageDataLogo = [];
    this.imageDataContent = [];

    if (this.entity.imageReferences.length > 0) {
      for (const image of this.entity.imageReferences) {
        if (image["imageType"] == this.externalpageImageTypes.MainImage) {
          this.imageDataMain = Object.assign({}, image);
        }

        if (image["imageType"] == this.externalpageImageTypes.GalleryImage) {
          this.imageDataGallery.push(image);
        }

        if (image["imageType"] == this.externalpageImageTypes.LogoImage) {
          this.imageDataLogo.push(image);
        }

        if (image["imageType"] == this.externalpageImageTypes.ContentImage) {
          this.imageDataContent.push(image);
        }
      }
    }
  }

  /**
   * Get preview link of external page based on type
   */
  getPreviewLink() {
    let result = this.domain.getCurrentDomain().url;

    switch (this.entity.type) {
      case externalpageTypes.Blog:
        result += "/blog/";
        break;

      case externalpageTypes.Event:
        result += "/events/";
        break;

      case externalpageTypes.Generic:
        result += "/pages/";
        break;

      case externalpageTypes.Project:
        result += "/projects/";
        break;

      case externalpageTypes.Testimonial:
        result += "/testimonials/";
        break;

      case externalpageTypes.School:
        result += "/pages/";
        break;

      case externalpageTypes.Video:
        result += "/videos/";
        break;
    }

    if (!empty(this.entity.permalink)) {
      result += this.entity.permalink;
    } else {
      result += this.entity.id;
    }

    return result;
  }

  /**
   * Delete the external page item
   *
   * @constructor
   */
  Delete() {
    if (empty(this.id) || typeof this.id !== "string") return;

    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm === true) {
          if (empty(this.id) || typeof this.id !== "string") return;

          this.isProcessing = true;

          this.externalpageService
            .apiDeleteExternalPage(this.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response) => {
              this.isProcessing = false;
              this.router.navigateByUrl(
                this.getPathOverviewByPageType(this.pageType)
              );
            });
        }
      })
      .catch((error) => {
        this.isProcessing = false;
      });
  }

  /**
   * Save
   *
   * Performs a pre-check for permalinks before saving definitely
   */
  Save() {
    this.isProcessing = true;

    if (empty(this.entity.permalink)) {
      this.setAutoPermalink();
    }

    // Pre-check permalink
    this.externalpageService
      .apiGetExternalPagePermalink(this.entity.permalink)
      .pipe(catchError(this.handleError("validatePermalink", false)), takeUntilDestroyed(this.destroyRef))
      .subscribe((response: any) => {
        this.isProcessing = false;
        if (response) {
          // Another object is found with same permalink, add suffix date
          if (!empty(response["id"]) && response["id"] != this.entity.id) {
            this.setAutoPermalink(true);
          }
        }

        this.saveDefinite();
      });
  }

  /**
   * Save a definite version of entity
   */
  saveDefinite() {
    this.isProcessing = true;

    // Update
    if (!empty(this.entity.id)) {
      this.externalpageService
        .apiUpdateExternalPage(this.entity.id, this.entity)
        .pipe(
          catchError(
            this.adminService.handleError("apiUpdateExternalPage", false)
          ),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe((result: any) => {
          this.isProcessing = false;

          if (result) {
            this.alertService.success(alertMessages.successDataSaved);
          }
        });
    }
    // Create
    else {
      this.externalpageService
        .apiAddExternalPage(this.entity)
        .pipe(
          catchError(this.adminService.handleError("apiAddExternalPage", false)),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe((result: any) => {
          this.isProcessing = false;

          if (result) {
            if (result.hasOwnProperty("id")) {
              this.alertService.success(alertMessages.successDataSaved);

              // Navigate to edit mode
              this.router.navigateByUrl(
                "/admin/externalpage/" + this.entity.type + "/" + result["id"]
              );
            }
          }
        });
    }
  }

  /**
   * On title change event
   *
   * @param $event
   */
  onTitleChange($event: any) {
    if (empty(this.displayPermalink)) {
      this.setAutoPermalink();
    }
  }

  /**
   * Check if save should be disabled due to validation errors
   */
  isSaveDisabled(): boolean {
    return this.isProcessing || this.permalinkValidationError !== "";
  }

  /**
   * Set a permalink automatically
   */
  setAutoPermalink($suffix = false) {
    const permalink = this.entity.title
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");

    if ($suffix) {
      this.displayPermalink = permalink + "-" + Math.floor(Date.now() / 1000);
    } else {
      this.displayPermalink = permalink;
    }

    // Update the actual permalink based on current toggle state
    this.updateActualPermalink();
    this.validatePermalink();
  }

  /**
   * Add a new image to single external page
   *
   * @param $externalpage_id
   * @param $imageType
   */
  addImage(
    $externalpage_id: string | null,
    $imageType = this.externalpageImageTypes.MainImage
  ) {
    if (empty($externalpage_id) || typeof $externalpage_id != "string") return;

    if ($imageType == this.externalpageImageTypes.MainImage) {
      if (!this.fileImageUrl) {
        return;
      } else {
        this.isProcessing = true;
        this.isProcessingMainImage = true;
      }
    }

    if ($imageType == this.externalpageImageTypes.GalleryImage) {
      if (!this.fileGalleryImageUrl) {
        return;
      } else {
        this.isProcessing = true;
        this.isProcessingGalleryImage = true;
      }
    }

    if ($imageType == this.externalpageImageTypes.ContentImage) {
      if (!this.fileContentImageUrl) {
        return;
      } else {
        this.isProcessing = true;
        this.isProcessingContentImage = true;
      }
    }

    const deleteImagePromise = new Promise((resolve, reject) => {
      // TODO: remove old main image before adding new one
      if (
        $imageType == this.externalpageImageTypes.MainImage &&
        this.entity.imageReferences.length > 0
      ) {
        const $imageIdsDelete = [];

        for (const image of this.entity.imageReferences) {
          if (image["imageType"] == this.externalpageImageTypes.MainImage) {
            $imageIdsDelete.push(image["id"]);
          }
        }

        if ($imageIdsDelete.length > 0) {
          for (const i in $imageIdsDelete) {
            const imageId = $imageIdsDelete[i];
            this.externalpageService
              .apiDeleteExternalPageImage($externalpage_id, imageId)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((result) => {
                resolve(true);
              });
          }
        } else {
          resolve(true);
        }
      } else {
        resolve(true);
      }
    });

    const $params = {
      imageType: $imageType,
    };

    // If deleted images are handled, proceed upload
    deleteImagePromise.then((value) => {
      if (value === true) {
        // First add a new entry
        this.externalpageService
          .apiCreateExternalPageImage($externalpage_id, $params)
          .pipe(
            catchError(
              this.externalpageService.handleError(
                "apiCreateExternalPageImage",
                false
              )
            ),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe((result: any) => {
            if (result) {
              const image_id = result.id;

              if ($imageType == this.externalpageImageTypes.MainImage) {
                this.isProcessingMainImage = true;
                fetch(this.fileImageUrl)
                  .then((res) => res.blob())
                  .then((blob) => {
                    const fd = new FormData();
                    const file = new File([blob], this.fileImageName);
                    fd.append("file", file);

                    // Finally upload the file
                    const API_URL =
                      this.api.getApiUrl() +
                      "/externalpage/" +
                      $externalpage_id +
                      "/images/" +
                      image_id +
                      "/data";
                    const headers = this.api.getUploadHeaders();
                    fetch(API_URL, {
                      method: "POST",
                      headers: headers,
                      body: fd,
                    })
                      .then((res) => {
                        this.isProcessing = false;
                        this.isProcessingMainImage = false;

                        if (res.status == 200) {
                          // Reload image data
                          this.getImages($externalpage_id);
                          this.clearFileUploaders(
                            this.externalpageImageTypes.MainImage
                          );
                        } else {
                          // Some error
                          this.isProcessing = false;
                          this.isProcessingMainImage = false;
                        }
                      })
                      .catch((error) => {
                        this.isProcessing = false;
                        this.isProcessingMainImage = false;
                      });
                  })
                  .catch(() => {
                    this.isProcessingMainImage = false;
                  });
              }

              if ($imageType == this.externalpageImageTypes.GalleryImage) {
                this.isProcessingGalleryImage = true;
                fetch(this.fileGalleryImageUrl)
                  .then((res) => res.blob())
                  .then((blob) => {
                    const fd = new FormData();
                    const file = new File([blob], this.fileGalleryImageName);
                    fd.append("file", file);

                    // Finally upload the file
                    const API_URL =
                      this.api.getApiUrl() +
                      "/externalpage/" +
                      $externalpage_id +
                      "/images/" +
                      image_id +
                      "/data";
                    const headers = this.api.getUploadHeaders();
                    fetch(API_URL, {
                      method: "POST",
                      headers: headers,
                      body: fd,
                    })
                      .then((res) => {
                        this.isProcessing = false;
                        this.isProcessingGalleryImage = false;

                        if (res.status == 200) {
                          // Reload image data
                          this.getImages($externalpage_id);
                          this.clearFileUploaders(
                            this.externalpageImageTypes.GalleryImage
                          );
                        } else {
                          // Some error
                          this.isProcessing = false;
                          this.isProcessingGalleryImage = false;
                        }
                      })
                      .catch((error) => {
                        this.isProcessing = false;
                        this.isProcessingGalleryImage = false;
                      });
                  });
              }

              if ($imageType == this.externalpageImageTypes.ContentImage) {
                this.isProcessingContentImage = true;
                fetch(this.fileContentImageUrl)
                  .then((res) => res.blob())
                  .then((blob) => {
                    const fd = new FormData();
                    const file = new File([blob], this.fileContentImageName);
                    fd.append("file", file);

                    // Finally upload the file
                    const API_URL =
                      this.api.getApiUrl() +
                      "/externalpage/" +
                      $externalpage_id +
                      "/images/" +
                      image_id +
                      "/data";
                    const headers = this.api.getUploadHeaders();
                    fetch(API_URL, {
                      method: "POST",
                      headers: headers,
                      body: fd,
                    })
                      .then((res) => {
                        this.isProcessing = false;
                        this.isProcessingContentImage = false;

                        if (res.status == 200) {
                          // Reload image data
                          this.getImages($externalpage_id);
                          this.clearFileUploaders(
                            this.externalpageImageTypes.ContentImage
                          );
                        } else {
                          // Some error
                          this.isProcessing = false;
                          this.isProcessingContentImage = false;
                        }
                      })
                      .catch((error) => {
                        this.isProcessing = false;
                        this.isProcessingContentImage = false;
                      });
                  });
              }
            } else {
              this.isProcessing = false;
              this.isProcessingMainImage = false;
              this.isProcessingGalleryImage = false;
              this.isProcessingContentImage = false;
            }
          });
      }
    });
  }

  /**
   * Delete a single image entry from a single external page
   *
   * @param $externalpage_id
   * @param $image_id
   */
  deleteImage($externalpage_id: string | null, $image_id: string | null) {
    if (empty($externalpage_id) || typeof $externalpage_id !== "string") return;
    if (empty($image_id) || typeof $image_id !== "string") return;

    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm === true) {
          this.isProcessing = true;

          this.externalpageService
            .apiDeleteExternalPageImage($externalpage_id, $image_id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response) => {
              this.isProcessing = false;

              // Reload image data
              this.getImages($externalpage_id);
            });
        }
      })
      .catch((error) => {
        this.isProcessing = false;
      });
  }

  /**
   * Clear file upload input data
   */
  clearFileUploaders($imageType = this.externalpageImageTypes.MainImage) {
    if ($imageType == this.externalpageImageTypes.MainImage) {
      this.fileImageName = "";
      this.fileImageUrl = "";
      this.fileMainImage = "";

      // Clear file input label
      this.inputFileMainImage.nativeElement.innerHTML = "";
      this.inputFileMainImage.nativeElement.dispatchEvent(new Event("change"));
    }

    if ($imageType == this.externalpageImageTypes.GalleryImage) {
      this.fileGalleryImage = "";
      this.fileGalleryImageUrl = "";
      this.fileGalleryImageName = "";

      // Clear file input label
      this.inputFileGalleryImage.nativeElement.innerHTML = "";
      this.inputFileGalleryImage.nativeElement.dispatchEvent(
        new Event("change")
      );
    }

    if ($imageType == this.externalpageImageTypes.ContentImage) {
      this.fileContentImage = "";
      this.fileContentImageUrl = "";
      this.fileContentImageName = "";

      // Clear file input label
      this.inputFileContentImage.nativeElement.innerHTML = "";
      this.inputFileContentImage.nativeElement.dispatchEvent(
        new Event("change")
      );
    }
  }

  /**
   * When file changes
   *
   * @param $event
   */
  onFileImageChange($event: any) {
    // Search for file name when input file changes
    if ($event.target.files && $event.target.files.length > 0) {
      for (let i = 0; i < $event.target.files.length; i++) {
        const file = $event.target.files[i];
        this.fileImageUrl = URL.createObjectURL(file);
        this.fileImageName = file.name;
      }
    }
  }

  /**
   * When file changes
   *
   * @param $event
   */
  onFileImageGalleryChange($event: any) {
    // Search for file name when input file changes
    if ($event.target.files && $event.target.files.length > 0) {
      for (let i = 0; i < $event.target.files.length; i++) {
        const file = $event.target.files[i];
        this.fileGalleryImageUrl = URL.createObjectURL(file);
        this.fileGalleryImageName = file.name;
      }
    }
  }

  /**
   * When file changes
   *
   * @param $event
   */
  onFileImageContentChange($event: any) {
    // Search for file name when input file changes
    if ($event.target.files && $event.target.files.length > 0) {
      for (let i = 0; i < $event.target.files.length; i++) {
        const file = $event.target.files[i];
        this.fileContentImageUrl = URL.createObjectURL(file);
        this.fileContentImageName = file.name;
      }
    }
  }

  /**
   * Copy image uri to clipboard
   *
   * @param $imageUri
   */
  copyImageUri($imageUri: string) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = $imageUri;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  /**
   * Get path to overview of a page type
   *
   * @param $pageType
   */
  getPathOverviewByPageType($pageType: string) {
    let result = "";
    switch ($pageType) {
      case externalpageTypes.Generic:
        result = "/admin/pages";
        break;

      case externalpageTypes.Project:
        result = "/admin/projects";
        break;

      case externalpageTypes.Event:
        result = "/admin/events";
        break;

      case externalpageTypes.Video:
        result = "/admin/videos";
        break;

      case externalpageTypes.Blog:
        result = "/admin/blogposts";
        break;

      case externalpageTypes.Testimonial:
        result = "/admin/testimonials";
        break;

      case externalpageTypes.School:
        result = "/admin/externalpageschools";
        break;

      default:
        result = "/admin";
        break;
    }

    return result;
  }

  /**
   * Error handler
   *
   * @param operation
   * @param result
   */
  handleError<T>(operation: string = "", result?: T) {
    return (error: any): Observable<T> => {
      // Handle given operation
      switch (operation) {
        case "validatePermalink":
          // Do not perform any action, profile could be non-existing
          break;

        default:
          this.modal.Alert("Error", "Something went wrong, please try again");
          break;
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
